import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../theme";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../components/Header";
import TableLender from "../../src/components/TableUserLender";
import TableBorrower from "../../src/components/TableUserBorrower";
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import warn_ico from "../assets/img/exclamation.png";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import {
  Form,
  Input,
  Select,
  Col,
  Row,
  Avatar,
  Upload,
  Card,
  Tabs,
  notification,
  DatePicker,
  Space,
  InputNumber,
  Modal,
  Button,
  message,
} from "antd";
import {
  EyeTwoTone,
  EyeInvisibleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";

const Users = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [sortBy, setSortBy] = useState("default");
  const [channel, setChannel] = useState("system");
  const [data, setData] = useState([]);
  const [subject, setSubject] = useState("");
  // const [message, setMessage] = useState("");
  const { TextArea } = Input;
  const [selectedBorrowerIds, setselectedBorrowerIds] = useState([]);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("")
  const [principal_name, setPrincipalName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setConfirmPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [error, setError] = useState("");
  const [reloadTable, setReloadTable] = useState(0);
  // const [reloadTable, setReloadTable] = useState(false); // Assuming initial value is false
  const [reloadTableBorrower, setReloadTableBorrower] = useState(0);
  const [screenWidth, setScreenWidth] = useState("1920");
  const [dataActivityLog, setActivityLog] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "dd MMMM yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  const ContainerRow1 = ({
    onClick,
    icon,
    title,
    subtitle,
    label,
    description,
  }) => (
    <div
      onClick={onClick} // The onClick event handler
      style={{
        width: screenWidth > 1200 ? "100%" : "100%",
        textAlign: "center",
        margin: "0px",
        border: "none",
        borderRadius: "10px",
        backgroundColor: "rgba(255,255,255,0.7)",
        cursor: "pointer",
        padding: "15px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h3
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "800",
            fontSize: "17px",
            color: "#142C44CC",
            textAlign: "left",
            margin: "0px",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "200",
            fontSize: "8px",
            color: "#142C44CC",
            textAlign: "right",
            margin: "0px",
          }}
        >
          {subtitle}
        </p>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: "13px",
        }}
      >
        <div
          style={{
            width: "55px",
            height: "55px",
            background: "rgba(0,0,0,0.03)",
            borderRadius: "35px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0px",
          }}
        >
          <img
            src={icon}
            alt={title}
            style={{
              background: "#f0f0f0",
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div
          style={{
            width: "calc(100% - 70px)",
            margin: "0px 0px 0px 10px",
          }}
        >
          <h3
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: "800",
              fontSize: "20px",
              textAlign: "left",
              color: "#142C44CC",
              margin: "0px",
            }}
          >
            {label}
          </h3>
          <p
            style={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: "600",
              fontSize: "11px",
              color: "rgba(0,0,0,0.4)",
              textAlign: "left",
              margin: "0px",
              lineHeight: "11px",
            }}
          >
            {description}
          </p>
        </div>
      </div>
      {/* <p>{description}</p> */}
    </div>
  );

  console.log("ParentComponent rendering", reloadTable);

  const handleRowClick = async (record) => {
    const userId = record.user_id;
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/viewUserDetail?user_id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      const json = await response.json();
      setData(json["User"]);
    } catch (error) {
      console.error("Error retrieving User:", error);
    }
  };

  const [newsletterList, setNewsletterList] = useState([]);

  const exportToExcel = () => {
    if (!newsletterList || newsletterList.length === 0) return;

    const processedData = newsletterList.map(({ id, email, created_at }) => ({
      ID: id,
      Email: email,
      "submitted on": formatDate(new Date(created_at)),
    }));

    const worksheet = XLSX.utils.json_to_sheet(processedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Newsletter List");
    XLSX.writeFile(workbook, "newsletter_list.xlsx");
  };

  const getNewsletterUsers = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/admin/getNewsletterUsers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      const json = await response.json();

      if (response.ok) {
        console.log(json.data);
        setNewsletterList(json.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getNewsletterUsers();
  }, []);

  const handleCreateLender = async () => {
    if (password !== passwordConfirmation) {
      setError("Passwords do not match");
      return; // Exit early
    }

    try {
      let item = {
        email: email,
        principal_name: principal_name,
        user_account_type: "lender",
        phone_number: phoneNumber,
        password: password,
        password_confirmation: passwordConfirmation,
      };

      const response = await fetch(
        "https://www.smart-lend.com/api/user/createLender",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(item),
        }
      );

      const data = await response.json();
      console.log("Response status:", response.status);
      console.log("Lender created:", data);

      if (response.status === 200) {
        if (data.error) {
          setError(data.error); // Handle backend error messages
          return;
        }

        const userId = data.user.user_id;
        if (selectedFile) {
          handleUploadProfilePicture(selectedFile, userId);
          setSelectedFile(null);
        }

        message.success("Lender Created Successfully");
        setReloadTable((prev) => prev + 1);
      } else {
        // Handle other non-200 status codes
        setError(`Unexpected response: ${response.status}`);
      }
    } catch (error) {
      console.error("Error during fetch operation:", error);
      setError("An error occurred while creating the lender.");
    }
  };

  const handleUploadProfilePicture = async (file, userId) => {
    console.log("uploading profile picture");
    try {
      const formData = new FormData();
      formData.append("profile_picture", file);
      formData.append("user_id", userId); // Add user_id to the formData

      const response = await fetch(
        "https://www.smart-lend.com/api/profile/uploadProfilePicture",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: formData,
        }
      );

      const data = await response.json();

      console.log("Profile picture created", data);

      // Update the imageUrl state with the new image URL
      if (data.profile_picture) {
        setImageUrl(data.profile_picture);
        Cookies.set("profile_picture", data.profile_picture);
        // message.success("Profile picture updated");
      } else if (data.error && data.error.profile_picture) {
        // If the profile picture failed to upload
        throw new Error(data.error.profile_picture[0]);
      }
    } catch (error) {
      console.error("Error Uploading Picture", error);
      setErrorMessage(error.message);
    }
  };

  const handleSelectionChange = (selectedBorrowerIds) => {
    console.log("Selected loan IDs:", selectedBorrowerIds);
    setselectedBorrowerIds(selectedBorrowerIds);
  };

  const handleSubmit = async (borrower_id) => {
    console.log("loanIds value in handleSubmit", borrower_id); // Debug statement

    try {
      let item = {
        user_id: borrower_id.join(","),
        channel: channel,
        subject: subject,
        message: message,
      };
      const response = await fetch(
        "https://www.smart-lend.com/api/user/notification/sendNotification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(item),
        }
      );
      const data = await response.json();
      console.log("Offer created:", data);
    } catch (error) {
      console.error("Error creating offer:", error);
    }
  };

  const getInitials = (name) => {
    const textToSplit = name.split(" ");
    const initials =
      textToSplit?.[0]?.[0].toUpperCase() +
      (textToSplit?.[1]?.[0].toUpperCase() || "");
    return initials;
  };

  const ContainerActivity = ({ icon, title, subtitle }) => (
    <div
      style={{
        width: "100%",
        textAlign: "left",
        marginBottom: "7px",
        border: "none",
        borderRadius: "10px",
        backgroundColor: "#FFFFFFB3",
        padding: "10px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            background: "rgb(140,140,170)",
            marginRight: "10px",
            marginLeft: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontSize: 20,
            fontWeight: 600,
            position: "relative",
          }}
        >
          {getInitials(title)}
        </div>
        <div style={{ width: "calc(100% - 75px)" }}>
          <h3
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 700,
              fontSize: "13px",
              color: "#435669",
              margin: "0px",
            }}
          >
            {title}
          </h3>
          <p
            style={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: "600",
              fontSize: "11px",
              color: "rgba(0,0,0,0.4)",
              margin: "0px",
            }}
          >
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );

  const ContainerActivity2 = ({ noData }) => (
    <div
      style={{
        width: "100%",
        padding: "0px 0px",
      }}
    >
      <div
        style={{
          width: "100%",
          padding: "0px 15px",
          background: "rgba(255,255,255,0.7)",
          borderRadius: "10px",
          height: "150px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "Manrope, sans-serif",
          fontSize: "0.8em",
          fontWeight: "600",
          color: "#00000066",
        }}
      >
        No activity log records
      </div>
    </div>
  );

  useEffect(() => {
    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "lender") {
      history.push("/dashboard");
    } else if (user_account_type === "borrower") {
      history.push("/b-dashboard");
    }
  }, [history]);

  const [modalStates, setModalStates] = useState({});
  const [allOfferedLoan, setAllOfferedLoan] = useState([]);
  const [label1, setLabel1] = useState(0);
  const [label2, setLabel2] = useState(0);
  const [label3, setLabel3] = useState(0);

  const calculateTotalOfferedAmount = (flatData) => {
    // Get the current date
    const currentDate = new Date();
    console.log(flatData);
    // Initialize a variable to store the total offered amount
    let totalOfferedAmount = 0;

    // Iterate through the array of loan offers
    flatData.forEach((offers) => {
      // Parse the loan's creation date
      const creationDate = new Date(offers.loan_details.created_at);

      // Check if the status is "ongoing" and the creation date is in the current month
      if (
        offers.status === "ongoing" &&
        creationDate.getMonth() === currentDate.getMonth() &&
        creationDate.getFullYear() === currentDate.getFullYear()
      ) {
        // Add the offer amount to the total
        totalOfferedAmount += offers.offer_amount;
      }
    });

    const formattedTotal = totalOfferedAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true, // Enable thousands/millions grouping
    });

    return formattedTotal;
  };

  const calculateTotalInterestProfit = (flatData) => {
    // Get the current date
    const currentDate = new Date();
    console.log(flatData);
    // Initialize a variable to store the total offered amount
    let totalOfferedAmount = 0;

    // Iterate through the array of loan offers
    flatData.forEach((offers) => {
      // Parse the loan's creation date
      const creationDate = new Date(offers.loan_details.created_at);

      // Check if the status is "ongoing" and the creation date is in the current month
      if (
        offers.status === "ongoing" &&
        creationDate.getMonth() === currentDate.getMonth() &&
        creationDate.getFullYear() === currentDate.getFullYear()
      ) {
        // Add the offer amount to the total
        totalOfferedAmount +=
          offers.loan_details.monthly_installment *
          offers.loan_details.interest_rate;
      }
    });

    const formattedTotal = totalOfferedAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true, // Enable thousands/millions grouping
    });

    return formattedTotal;
  };

  const calculateTotalLoanRequest = (flatData) => {
    // Get the current date
    const currentDate = new Date();
    console.log(flatData);
    // Initialize a variable to store the total offered amount
    let totalOfferedAmount = 0;

    // Iterate through the array of loan offers
    flatData.forEach((offers) => {
      // Parse the loan's creation date
      const creationDate = new Date(offers.created_at);

      // Check if the status is "ongoing" and the creation date is in the current month
      if (
        creationDate.getMonth() === currentDate.getMonth() &&
        creationDate.getFullYear() === currentDate.getFullYear()
      ) {
        // Add the offer amount to the total
        totalOfferedAmount += 1;
      }
    });

    return totalOfferedAmount;
  };

  const [loanRequests, setLoanRequests] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/viewLoanRequest",
          {
            headers: {
              Authorization: "Bearer " + Cookies.get("token"),
              Accept: "application/json",
            },
          }
        );
        const json = await response.json();
        const flatData = json["Requested Loan"].flat();
        setLoanRequests(json["Requested Loan"]);
        console.log(json["Requested Loan"]);
        setLabel3(calculateTotalLoanRequest(flatData));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);
  const [messages, setMessages] = useState([]);
  const [currentUserId, setCurrentUserId] = useState("");

  const checkReadId = (data, userId = currentUserId) => {
    if (!data || !userId) {
      return false;
    }

    const isRead = (value) =>
      value === true || value === 1 || value === "1" || value === "true";

    if (data.user_id1 === userId) {
      return !isRead(data.read_id1);
    }

    if (data.user_id2 === userId) {
      return !isRead(data.read_id2);
    }

    return false;
  };

  useEffect(() => {
    const getMessage = async () => {
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/message/getMessage",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );

        const json = await response.json();
        let messagessss = [];
        if (response.status === 200) {
          setCurrentUserId(json.user_id);
          if (json.data.length > 0) {
            messagessss = [...json.data];
          }
          // Remove parameters from the URL
          setMessages(messagessss);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getMessage();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/loanOffer/viewAllOfferedLoan",
          {
            headers: {
              Authorization: "Bearer " + Cookies.get("token"),
              Accept: "application/json",
            },
          }
        );
        const json = await response.json();
        const flatData = json["Loan offers"].flat();
        setAllOfferedLoan(flatData);
        setLabel1(calculateTotalOfferedAmount(flatData));
        setLabel2(calculateTotalInterestProfit(flatData));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const initialStates = {};
    data.forEach((item) => {
      initialStates[item.user_id] = false;
    });
    setModalStates(initialStates);
  }, [data]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/profile/viewActivityLog",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setActivityLog(data.all_activity_log);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleBeforeUpload = (file) => {
    const imageUrl = URL.createObjectURL(file);
    setImageUrl(imageUrl);
    console.log("Photo ready to upload", file);
    setSelectedFile(file);
    return false; // Prevent file from being uploaded automatically
  };

  const [open, setOpen] = useState(false);
  const [openBorrowerIds, setOpenBorrowerIds] = useState([]);

  const showModal = (user_id, event) => {
    event.preventDefault();
    console.log("user_id modal", user_id);
    setOpenBorrowerIds((prevStates) => [...prevStates, ...user_id]);
  };

  const handleClose = (selectedUserId) => {
    setOpenBorrowerIds((prevStates) =>
      prevStates.filter((id) => id !== selectedUserId)
    );
  };

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 16,
    },
    vertical: true,
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const tailLayout = {
    wrapperCol: {
      offset: 9,
      span: 24,
    },
  };

  const ContainerTransaction = ({ title, label }) => (
    <div
      style={{
        width: "45%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginLeft: "30px",
      }}
    >
      <div style={{ flex: 1, textAlign: "left", marginLeft: "0px" }}>
        <h3
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "17px",
            color: "#142C44CC",
            flex: 1,
            marginTop: "5px",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "800",
            fontSize: "20px",
            color: "#435669",
            marginTop: "5px",
          }}
        >
          {label}
        </p>
      </div>
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box m="4px 20px 20px 20px">
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        <Box
          gridColumn="span 9"
          gridRow="span 2"
          height="100vh"
          width="100%"
          borderRadius="10px"
          border="0px solid "
          opacity="0.95"
          style={{
            overflowY: "scroll",
            overflowX: "hidden",
            background:
              "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="95%"
            borderRadius="10px"
            margin="20px 20px 20px 20px"
            style={{ gap: "5px" }}
          >
            <div style={{ width: "32%" }}>
              <ContainerRow1
                key={0}
                icon={require("../assets/img/customersicon.png")}
                title="Total Loan Amount"
                label={label1}
                description={"Loan processed this month"}
              />
            </div>
            <div style={{ width: "32%" }}>
              <ContainerRow1
                key={0}
                icon={require("../assets/img/businessanalyticsicon.png")}
                title="Interest Profit"
                label={label2}
                description={"Made this month"}
              />
            </div>
            <div style={{ width: "32%" }}>
              <ContainerRow1
                key={0}
                icon={require("../assets/img/applicationicon.png")}
                title="Loan Request"
                label={label3}
                description={"Request made this month"}
              />
            </div>
          </Box>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "calc(100% - 40px)",
              marginLeft: "20px",
            }}
          >
            <div
              style={{
                fontWeight: 800,
                fontFamily: "Manrope, sans-serif",
                fontSize: "18px",
                color: "#142C44CC",
              }}
            >
              Platform Newsletter
            </div>
            <div
              onClick={() => exportToExcel()}
              className="mui_button"
              style={{
                padding: "8px 25px",
                borderRadius: "8px",
                color: "white",
                backgroundColor: "rgb(17, 92, 166)",
              }}
            >
              Export to Excel
            </div>
          </div>
          <div
            style={{
              width: "calc(100% - 40px)",
              marginLeft: "20px",
              height: "350px",
              background: "rgb(256,256,256, 0.9)",
              borderRadius: "8px",
              marginTop: "20px",
              overflowY: "auto",
              padding: "5px",
            }}
          >
            {newsletterList.map((newsuser, index) => (
              <div
                className="hover_list"
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "5px 12px",
                }}
              >
                <div>{newsuser.email}</div>
                <div>
                  {"Submitted on " + formatDate(new Date(newsuser?.created_at))}
                </div>
              </div>
            ))}
          </div>
          <Box
            display="flex"
            alignItems="flex-start"
            width="100%"
            borderRadius="10px"
            margin="20px 20px 20px 20px"
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="18px"
            >
              Create Lender
            </Typography>
          </Box>

          <Box
            gridColumn="span 2"
            gridRow="span 2"
            background="transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box"
            border-radius="20px"
            opacity="0.95"
            paddingBottom="120px"
            marginLeft="20px"
          >
            <Card
              style={{
                overflowY: "scroll",
                minHeight: "10.7vh",
                width: "98%",
                justifyContent: "center",
              }}
            >
              <Form
                style={{ minHeight: "10.7vh" }}
                {...layout}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                {/* <Row style={{ marginBottom: "10px" }}>
                      <Col span={12}>
                        <Upload
                          beforeUpload={handleBeforeUpload}
                          showUploadList={false}
                          fileList={selectedFile ? [selectedFile] : []}
                        >
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              // alt="Profile picture"
                              style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "50px",
                                // marginTop:"-3vh",
                                // marginBottom:"0.5vh"
                              }}
                            />
                          ) : (
                            <Avatar
                              className="profile-picture-lender"
                              icon={<UserOutlined />}
                            />
                          )}
                        </Upload>
                      </Col>
                    </Row> */}
                <Row>
                  <Col span={12}>
                    <Form.Item label="Name">
                      <Input
                        style={{ width: "100%" }}
                        type="text"
                        placeholder="John Wick"
                        value={principal_name}
                        onChange={(e) => setPrincipalName(e.target.value)}
                        required
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Email" name="email">
                      <Input
                        style={{ width: "100%" }}
                        type="email"
                        placeholder="test123456@gmail.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item label="Phone number">
                      <Input
                        style={{ width: "100%" }}
                        type="text"
                        value={phoneNumber}
                        placeholder="6512345678"
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        required
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item label="Password" name="password">
                      <Input
                        style={{ width: "100%" }}
                        type={visible ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        suffix={
                          <span
                            style={{
                              position: "absolute",
                              right: 5,
                              bottom: 8,
                            }}
                          >
                            {visible ? (
                              <EyeTwoTone onClick={() => setVisible(false)} />
                            ) : (
                              <EyeInvisibleOutlined
                                onClick={() => setVisible(true)}
                              />
                            )}
                          </span>
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item label="Confirm Password" name="confirm-password">
                      <Input
                        style={{ width: "100%" }}
                        type={visible2 ? "text" : "password"}
                        value={passwordConfirmation}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        suffix={
                          <span
                            style={{
                              position: "absolute",
                              right: 5,
                              bottom: 8,
                            }}
                          >
                            {visible2 ? (
                              <EyeTwoTone onClick={() => setVisible2(false)} />
                            ) : (
                              <EyeInvisibleOutlined
                                onClick={() => setVisible2(true)}
                              />
                            )}
                          </span>
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <hr
                  style={{
                    color: "#142C44CC",
                    height: "2px",
                    width: "96.5%",
                  }}
                />

                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => handleCreateLender()}
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                      fontWeight: 600,
                      marginLeft: "10px",
                      borderRadius: "10px",
                      width: "25%",
                      background:
                        "rgba(21,87,169,1)",
                      height: "40px",
                    }}
                  >
                    Submit
                  </Button>
                  {error && (
                    <p style={{ color: "red", marginLeft: "1.3vw" }}>{error}</p>
                  )}
                </Form.Item>
              </Form>
            </Card>
          </Box>
        </Box>

        <Box
          gridColumn="span 3"
          gridRow="span 2"
          height="89vh"
          borderRadius="20px"
          border="0px solid white"
          //  style={{
          //    background:
          //      "transparent linear-gradient(0deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
          //  }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            // borderBottom={`4px solid ${colors.primary[500]}`}
            colors={colors.grey[910]}
            marginTop="-15px"
            marginBottom="10px"
            p="15px"
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="18px"
            >
              Admin Summary of the day
            </Typography>
          </Box>
          <div
            style={{
              // background: "red",
              width: "100%",
              height: "80vh",
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            {loanRequests
              .filter((dat) => {
                const createdAt = new Date(dat.created_at);
                const now = new Date();
                const days30Ago = new Date(now.setDate(now.getDate() - 30));

                const isRecent = createdAt >= days30Ago;

                return (
                  isRecent &&
                  dat.visibility === 0 &&
                  (dat.make_hidden === 1 ||
                    dat.employee === 1 ||
                    dat.sole_prop === 1 ||
                    dat.corporate_structure === 1 ||
                    (dat.authorization_required === 1 &&
                      Array.isArray(dat.loan_authorizations) &&
                      dat.loan_authorizations.some(
                        (auth) => auth.authorized === 0
                      )))
                );
              })
              .map((data, index) => (
                <div
                  key={index}
                  style={{
                    padding: "15px",
                    borderRadius: "12px",
                    background: "white",
                    marginBottom: "10px",
                    color: "grey",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div
                    className="blink"
                    style={{
                      height: "8px",
                      width: "8px",
                      borderRadius: "50%",
                      background: "green",
                    }}
                  />
                  <div style={{ width: "calc(100% - 20px)" }}>
                    A loan by{" "}
                    <span
                      style={{ color: "rgb(17, 92, 166)", fontWeight: 700 }}
                    >
                      {data.principal_name}
                    </span>{" "}
                    is currently{" "}
                    {data.make_hidden === 1 ? "set to hidden," : ""}
                    {data.loan_offer_count !== 0
                      ? "but it does already have an offer by a lender"
                      : ""}
                    {data.employee === 1 && data.visibility === 0
                      ? "hidden because it is under an employee,"
                      : ""}
                    {data.sole_prop && data.visibility === 0
                      ? "hidden because it is a sole prop company,"
                      : ""}{" "}
                    {data.corporate_structure && data.visibility === 0
                      ? "hidden because it is a corporate structured loan,"
                      : ""}
                    {data.authorization_required === 1 &&
                    Array.isArray(data.loan_authorizations) &&
                    data.loan_authorizations.some(
                      (auth) => auth.authorized === 0
                    )
                      ? "hidden because it is pending authorisation from other directors."
                      : ""}
                  </div>
                </div>
              ))}
            {messages
              .filter(
                (mes) => checkReadId(mes, currentUserId) && mes.archive === 0
              )
              .map((dat1, index1) => (
                <div
                  style={{
                    padding: "15px",
                    borderRadius: "12px",
                    background: "white",
                    marginBottom: "10px",
                    color: "grey",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  key={index1}
                >
                  <div
                    className="blink"
                    style={{
                      height: "8px",
                      width: "8px",
                      borderRadius: "50%",
                      background: "green",
                    }}
                  />
                  <div style={{ width: "calc(100% - 20px)" }}>
                    There is a pending message from{" "}
                    <span
                      style={{ color: "rgb(17, 92, 166)", fontWeight: 700 }}
                    >
                      {dat1.entityName}
                    </span>{" "}
                    please handle the message and archive the
                    conversation when it's complete.
                  </div>
                </div>
              ))}
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Users;
